import React, { useState } from 'react';
import { Modal, Timeline, Typography, Spin } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Container from '@app/components/General/Container';
import { getHistory } from '../../../../apis/CreditoFonacotApi';
import moment from 'moment';

const { Text } = Typography;

const TimelineModal = ({ creditoId, numeroCredito }) => {
    const [_open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const showModal = async () => {
        setLoading(true);
        await getData();
        setOpen(true);
        setLoading(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const getData = async () => {
        try {
            const response = await getHistory(creditoId);
            if (response.ok) {
                let history = response.payload;
                let listEvents = [];

                for (let index = 0; index < history.length; index++) {
                    const item = history[index];
                    let date = moment(item.date_updated).format('DD/MM/YYYY HH:mm');
                    
                    listEvents.push({
                        color: 'blue',
                        children: (
                            <>
                                <Text>
                                    Abono realizado en el periodo {item.num_periodo}/{item.anio}
                                </Text>
                                <br />
                                <Text type="secondary">{date}</Text>
                                <br />
                                <Text strong>
                                    {item.saldo_anterior} → {item.saldo_nuevo}
                                </Text>
                                <br />
                                <Text type="secondary">
                                    Cambio: {item.monto_cambio}
                                </Text>
                            </>
                        )
                    });
                }

                setData(listEvents);
            }
        } catch (err) {
            console.error("Error obteniendo historial:", err);
        }
    };

    return (
        <>
            <span><InfoCircleOutlined style={{marginRight: 5, color: '#2E2D75'}} onClick={showModal}/></span>
            {_open && (
                <Modal
                    title={`Historial de cambios - Crédito ${numeroCredito}`}
                    open={_open}
                    onCancel={handleCancel}
                    footer={null}
                    width={600}
                >
                    <Container>
                        {loading ? (
                            <Spin />
                        ) : data.length === 0 ? (
                            <Text type="secondary">No hay historial disponible</Text>
                        ) : (
                            <Timeline mode="left" items={data} />
                        )}
                    </Container>
                </Modal>
            )}
        </>
    );
};

export default TimelineModal;

